module.exports = __webpack_public_path__ + "static/media/getty_Images_1204596112_mobile.8ac35b0e.jpg";